import { Controller } from 'react-hook-form';
import { TextField } from 'ui-components';

type Props = {
  name: string;
};

export default function ControlledNumberField({ name }: Props): JSX.Element {
  return (
    <Controller
      name={name}
      render={({ field: { value, onChange } }) => (
        <div className="relative">
          <TextField
            type="number"
            value={value}
            name={name}
            onChange={(event) => onChange(Number(event.target.value))}
            className="text-right w-36 border-1 border-zinc-300 bg-white pr-10"
            autoComplete="off"
          />
          <span className="antialiased text-sm absolute right-3 top-0 h-full flex items-center pointer-events-none text-zinc-500">
            mm
          </span>
        </div>
      )}
    />
  );
}
